import { gql } from 'urql'

export const FragAttendedSessionsPageSection = gql`
  fragment AttendedSessionsPageSection on AttendedSessionsPageSection {
    __typename
    title
    items {
      ... on SessionCard {
        ...SessionCard
      }
    }
  }
`
